import React, { useState, useEffect } from 'react'
import styles from './ReviseAndContinue.module.scss'
import Button from '../../../partials/Button'
import HTMLContent from '../../../partials/HTMLContent'
import Media from '../../../partials/Media'


const RevisedAndContinue = (props) => {

    const {onContinue, onRevise, data } = props

    return (
        <div className={styles.revise} >

            <div className={styles.panel}>
                <HTMLContent >
                    <h2>{data?.title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: data?.content }}></p>
                </HTMLContent>

                <Button text="revise" size="small" onClick={onRevise} />
            </div>

            <div className={styles.panel}>

                <Media 
                  type={'image'}
                  src={ data?.image}
                  alt={ data?.alt}
                />

                <Button text="Next" onClick={onContinue} />

            </div>
        </div>

    )
}

export default RevisedAndContinue
